import { useState } from 'react'

import SaveIcon from '@mui/icons-material/Save'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Collapse from '@mui/material/Collapse'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

import { SelectString } from '../../../../core/components/SelectString'
import type { ProcesstapHoofdleiding } from '../../../../status/types/ProcesstapHoofdleiding'
import { useSaveEvent } from '../../hooks/useSaveEvent'
import type { HoofdleidingProject } from '../../types/HoofdleidingProject'

type Props = {
  project: HoofdleidingProject
  handleClose: () => void
  processtappen: ProcesstapHoofdleiding[]
}

export const Processtap = ({ project, handleClose, processtappen }: Props) => {
  const { mutate: saveEvent } = useSaveEvent()

  const [processtap, setProcesstap] = useState<string | null>(
    project.statusText,
  )

  const handleSave = () => {
    if (processtap) {
      saveEvent(
        {
          type: 'hoofdleiding_processtap',
          id: project.aanvraagID,
          source: 'manual',
          data: { statusText: processtap },
        },
        {
          onSuccess: () => handleClose(),
        },
      )
    }
  }

  return (
    <>
      <DialogTitle>Processtap wijzigen</DialogTitle>
      <DialogContent>
        <SelectString
          label="Processtap"
          options={processtappen}
          sx={{ width: '50%', pr: 2 }}
          onChange={setProcesstap}
          value={processtap}
        />

        <Collapse in={processtap === 'Geannuleerd'} unmountOnExit>
          <Alert severity="error" sx={{ mt: 2, mb: 2 }}>
            Een project annuleren is onomkeerbaar, de onderliggende bijlagen en
            activiteiten worden ook geannuleerd.
          </Alert>
        </Collapse>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} variant="text">
          Annuleren
        </Button>
        <Button
          disabled={project.statusText === processtap}
          onClick={handleSave}
          variant="contained"
          endIcon={<SaveIcon />}
        >
          Opslaan
        </Button>
      </DialogActions>
    </>
  )
}
